import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Neighbor
const GQLAddNeighborhoodImage = gql`
  mutation addNeighborhoodImage(
    $imageurl: String
    $thumbnailurl: String
    $neighborhoodId: String
    $user_id: String
    $caption: String
    $photocategory: String
    $date: String
    $username: String
    $userrole: String
    $userimage: String
  ) {
    addNeighborhoodImage(
      imageurl: $imageurl
      thumbnailurl: $thumbnailurl
      neighborhoodId: $neighborhoodId
      user_id: $user_id
      caption: $caption
      photocategory: $photocategory
      date: $date
      username: $username
      userrole: $userrole
      userimage: $userimage
    ) {
      success
      message
    }
  }
`;

//Update Neighbor
const Updateneighborhood = gql`
  mutation updateneighbor($id: String, $walkscorestatus: String) {
    updateNeighborhood(id: $id, walkscorestatus: $walkscorestatus) {
      success
      message
    }
  }
`;

const UpdateneighborhoodImage = gql`
  mutation UpdateneighborhoodImage($id: String, $caption: String) {
    UpdateneighborhoodImage(id: $id, caption: $caption) {
      success
      message
    }
  }
`;

const UpdateNeighborhoodRate = gql`
  mutation UpdateNeighborhoodRate($id: String, $rate: Int) {
    UpdateNeighborhoodRate(id: $id, rate: $rate) {
      success
      message
    }
  }
`;

const UpdateNeighborhoodHelpful = gql`
  mutation UpdateNeighborhoodHelpful($id: String) {
    UpdateNeighborhoodHelpful(id: $id) {
      success
      message
    }
  }
`;

//Delete Neighbor
const Deleteneighborhood = gql`
  mutation DeleteNeighbor($id: String) {
    deleteNeighborhood(id: $id) {
      success
      message
    }
  }
`;

//Delete Neighbor
const deleteNeighborhoodImage = gql`
  mutation deleteNeighborhoodImage($id: String) {
    deleteNeighborhoodImage(id: $id) {
      success
      message
    }
  }
`;

const GQLHelpImageReviews = gql`
  mutation helpnhimagesreviews(
    $reviewId: String
    $neighborhoodId: String
    $userId: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
  ) {
    helpnhimagesreviews(
      reviewId: $reviewId
      neighborhoodId: $neighborhoodId
      userId: $userId
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

const GQLupdatenhsummaryimage = gql`
  mutation updatenhsummaryimage($id: String) {
    updatenhsummaryimage(id: $id) {
      success
      message
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addNeighborhoodImage(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddNeighborhoodImage,

        variables: {
          imageurl: adddata.imageurl,
          thumbnailurl: adddata.thumbnailurl,
          neighborhoodId: adddata.neighborhoodId,
          user_id: adddata.user_id,
          caption: adddata.caption,
          photocategory: adddata.photocategory,
          date: adddata.date,
          username: adddata.username,
          userrole: adddata.userrole,
          userimage: adddata.userimage,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateNeighborhood(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Updateneighborhood,

        variables: {
          id: updatedata.id,
          walkscorestatus: updatedata.walkscorestatus,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function UpdateNeighborhoodImage(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: UpdateneighborhoodImage,

        variables: {
          id: updatedata.id,
          caption: updatedata.caption,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function UpdateNeighborhoodrate(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: UpdateNeighborhoodRate,

        variables: {
          id: updatedata.id,
          rate: updatedata.rate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function UpdateNeighborhoodhelpful(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: UpdateNeighborhoodHelpful,
        variables: {
          id: updatedata.id,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Delete Function

async function DeleteNeighborhoodImage(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: deleteNeighborhoodImage,
        variables: {
          id: deletedataId.id,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function deleteNeighborhood(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: Deleteneighborhood,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllNeighborList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllNeighborList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
async function helpnhimagesreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpImageReviews,
        variables: {
          reviewId: adddata.reviewId,
          neighborhoodId: adddata.neighborhoodId,
          userId: adddata.userId,
          helpStatus: adddata.helpStatus,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updatenhsummaryimage(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLupdatenhsummaryimage,
        variables: {
          id: adddata.nhid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addNeighborhoodImage,
  updateNeighborhood,
  deleteNeighborhood,
  getAllNeighborList,
  DeleteNeighborhoodImage,
  UpdateNeighborhoodImage,
  UpdateNeighborhoodrate,
  UpdateNeighborhoodhelpful,
  helpnhimagesreview,
  updatenhsummaryimage,
};
